import React from 'react';
import { Chip, Tooltip, Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ScoreGrade } from '../../types/models';

interface ScoreBadgeProps {
  grade: ScoreGrade;
  score?: number;
  confidence?: 'high' | 'medium' | 'low';
  size?: 'small' | 'medium';
  overridden?: boolean;
}

const GRADE_COLORS: Record<ScoreGrade, string> = {
  AA: '#2e7d32',
  A:  '#388e3c',
  B:  '#f57c00',
  C:  '#e64a19',
  D:  '#d32f2f',
};

const CONFIDENCE_TOOLTIP: Record<string, string> = {
  high:   'Alta confianza — historial suficiente',
  medium: 'Confianza media — historial parcial',
  low:    'Baja confianza — datos insuficientes',
};

const ScoreBadge: React.FC<ScoreBadgeProps> = ({
  grade,
  score,
  confidence,
  size = 'medium',
  overridden = false,
}) => {
  const color = GRADE_COLORS[grade] ?? '#9e9e9e';
  const label = score !== undefined
    ? `${grade} · ${score.toFixed(0)}`
    : grade;

  const chip = (
    <Chip
      label={size === 'small' ? grade : label}
      size={size}
      sx={{
        backgroundColor: color,
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: '0.04em',
        fontSize: size === 'small' ? '0.7rem' : '0.85rem',
        height: size === 'small' ? 24 : 32,
      }}
    />
  );

  const overrideMark = overridden ? (
    <Tooltip title="Rating modificado manualmente por un administrador" arrow>
      <EditIcon
        fontSize="inherit"
        sx={{
          fontSize: size === 'small' ? '0.9rem' : '1rem',
          color: 'text.secondary',
        }}
      />
    </Tooltip>
  ) : null;

  if (confidence || overrideMark) {
    return (
      <Tooltip title={confidence ? (CONFIDENCE_TOOLTIP[confidence] ?? '') : ''} arrow disableHoverListener={!confidence}>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          {chip}
          {confidence === 'low' && (
            <Typography component="span" variant="caption" color="text.disabled">~</Typography>
          )}
          {overrideMark}
        </Box>
      </Tooltip>
    );
  }

  return chip;
};

export default ScoreBadge;
